<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/iUN4S3/tc-custom/9781644572191.jpg?1731055680177" alt="This image is the cover for the book Christ-Centered Fitness"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Christ-Centered Fitness
      </h1>
      <p class="bookDescription body article font2">
        <b>You are a unique creation…no one can take your place. It’s time to take your life OFF OF HOLD and seize victory in every aspect of life with <i>Christ-Centered Fitness.</i></b><br/><br/>God has specifically called you to do mighty things for Him, but are you prepared to maximize that calling with a fit body? Your body is the vessel by which you preach the gospel, serve others, and live out your abundant life. This vessel needs to be healthy!<br/><br/>With shackles such as low energy, obesity, sickness, and sedentary lifestyles, people feel restricted and incapable of serving the Lord to the best of their ability.<br/><br/>Jason Berry shows you how to achieve a state of physical fitness and health that is readily prepared to accomplish the will of the Father. In his easy-to-understand style, he outlines everything needed from Biblical fundamentals to workout plans. You’ll discover ways to win the battle inside your mind, overcome by faith, Biblical truths for health—all at your fingertips.<br/><br/>This is YOUR appointed time for victory. Grab a water bottle, double-knot your sneakers, break the shackles, and claim your place…it’s time for Christ-Centered Fitness!<br/><br/><b>“This book fills a niche for Christians' health and shows God’s intention for His followers.”</b><i> ~Patricia London (D. Ed. Adjunct Assistant Professor, Health and Physical Education, Messiah College)</i><br/><br/><b>“Jason uses Biblical truths to present a fresh Christian perspective to physical fitness.”</b><i> ~James Smith (Retired Supervisor of Health, Physical Education, and Aquatics, Cumberland Valley School District)</i><br/><br/><b>About the Author</b><br/>Dynamic speaker, youth pastor, PE teacher, U.S. Military veteran, and certified personal trainer, Jason Berry's diverse fitness experience ranges from Iraq's battlefields to a master's degree in Exercise Science. His passion for fitness is surpassed only by his passion for Christ and his family.<br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jason Berry
      </h2>
      
      <p class="authorDescription body article">Dynamic speaker, youth pastor, PE teacher, U.S. Military veteran, and certified personal trainer, Jason Berry's diverse fitness experience ranges from Iraq's battlefields to a master's degree in Exercise Science. His passion for fitness is surpassed only by his passion for Christ and his family.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Rise UP Publications
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?49c74420